<script lang="ts">
/*
Loading Icon
*/
import { defineComponent, nextTick } from 'vue'
export default defineComponent({

async mounted()
{

},
props:
{
    size:{type:Number, default:80},
    date_in:{type:Date, default:new Date()},
},
data() 
{
        return {
        date_s:"1963-04-20",
        date_selected:new Date()
        };
    },
    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
    computed: {
        cssProps() {
      return {
        '--size': (this.size ) + "px",
        '--ring_size': (this.size *(64/80) ) + "px",
        '--ring_margin': (this.size*(8/80) ) + "px",

      }
    }
  },
  methods:
  {
    

  },
  watch : 
    {

    },
});
</script>

<template>
    <div class="lds-ring" :style="cssProps"><div></div><div></div><div></div><div></div></div>
</template>

<style scoped>
/* from: https://loading.io/css/*/
.lds-ring {
  display: inline-block;
  position: relative;
  width: var(--size);
  height: var(--size);
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: var(--ring_size);
  height: var(--ring_size);
  margin: var(--ring_margin);
  border: var(--ring_margin) solid #fcf;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fcf transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>